import { render, staticRenderFns } from "./CompletedProcesses.vue?vue&type=template&id=31694812&"
import script from "./CompletedProcesses.vue?vue&type=script&lang=js&"
export * from "./CompletedProcesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports